import { format } from 'date-fns';

export const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const convertUTCDateToLocalDate = (inputDate: Date, dateOnly?: boolean) => {
  const date = new Date(inputDate);
  if (dateOnly) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
};

export const formatDate = (date: Date | string | null) => {
  if (!date) {
    return '';
  }

  return format(new Date(date), 'M/d/yyyy');
};

export const formatDateShort = (date: Date | string | null) => {
  if (!date) {
    return '';
  }

  return format(new Date(date), 'M/d/yy');
};

export const formatDateTime = (date: Date | string | null) => {
  if (!date) {
    return '';
  }

  return format(new Date(date), 'M/d/yyyy, h:mm a').toLowerCase();
};
